import { Command } from 'commander'
import { LoginCommand } from './login'
import { LogoutCommand } from './logout'
import { WhoAmICommand } from './whoami'

const authCommands = [LoginCommand, WhoAmICommand, LogoutCommand]

const authDomain = new Command('auth')
authDomain.description('Manage authorization on scalar platform')
authCommands.forEach((command) => authDomain.addCommand(command()))
export default authDomain
